import { Box } from '@ads-core/components';
import { renderJssLink } from '@alliander-fe/jss-utils';
import { LinkField } from '@sitecore-jss/sitecore-jss-nextjs';
import { TasksProps } from 'components/CongestionReportsHero';

export const getFilteredTopTasks = (tasks?: TasksProps[]) => {
  if (!tasks) return [];

  const topTasks = tasks.map(({ fields: { link, title, color } }) => {
    const taskText = title.value?.toString();
    const linkLabel = taskText || link.value.text || 'Klik hier voor meer informatie';

    const linkField: LinkField = {
      ...link,
      value: {
        ...link.value,
        text: linkLabel,
      },
    };

    return {
      link: renderJssLink(
        linkField,
        <Box position="relative" zIndex="1" as="span">
          {taskText}
        </Box>
      ),
      arrowLink: renderJssLink(linkField),
      arrowLabel: linkLabel,
      color: color?.value ?? 'purple',
      isAnchor: Boolean(link.value.anchor),
      href: link.value.href,
    };
  });

  type MappedTopTasks = (typeof topTasks)[number];
  type RequiredTopTasks = Omit<MappedTopTasks, 'link'> & {
    link: NonNullable<MappedTopTasks['link']>;
  };

  return topTasks.filter((t): t is RequiredTopTasks => !!t.link);
};
